<div style="display: grid; grid-template-columns: [first] 550px [second] auto; width: 100%; height: calc(100vh - 54px); margin-top: 0; padding: 0;">
    <div class="d-flex flex-column login-component h-100 justify-content-between flex-grow-1">

        <div class="d-flex flex-column justify-content-start  h-100 gap-4 flex-grow-1">
            <h3>Zapomniałeś hasła?</h3>

            <p>Nie martw się! Wpisz adres e-mail powiazany z Twoim kontem, a wyślemy Ci link do zresetowania hasła.
            </p>

            <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
                <mat-form-field appearance="outline" style="width:100%;">
                    <mat-label>E-mail</mat-label>
                    <input matInput type="email" placeholder="E-mail" required [errorStateMatcher]="matcher"
                        formControlName="email">
                    @if (resetForm.hasError('email') && !resetForm.hasError('required')) {
                    <mat-error>Podany adres e-mail jest nieprawidłowy</mat-error>
                    }
                    @if (resetForm.hasError('required')) {
                    <mat-error>Proszę wprowadzić e-mail</mat-error>
                    }
                </mat-form-field>
                <div class="d-flex flex-row justify-content-end align-items-center mb-3">
                    <a class="underline-link" (click)="router.navigate(['/'])">Strona logowania</a>
                </div>

                <div class="button">
                    <button style="width:100%;" type="submit" mat-flat-button color="tertiary" appearance="outline"
                        [disabled]="!resetForm.valid">Resetuj hasło</button>
                </div>
            </form>
        </div>
        <app-social-media></app-social-media>
    </div>
    <div class="rekbot-img d-flex flex-column flex-grow-1"></div>
</div>